import { EventEmitter } from "pixi.js";

export enum EnumEventBus {
  setCalcLine = "SET_CALC_LINE",
  showCalcLine = "SHOW_CALCULATION_LINE",
  drawElements = "DRAW_ELEMENTS",
  setCalcForAnim = "SET_CALCULATION_LINE_FOR_ANIMATION",
  showSliders = "SHOW_SLIDERS",
  setCircumPoint = "SET_CIRCUMFERENCE_POINT",
  setCentralAngle = "SET_CENTRAL_ANGLE",
  setRotateCircle = "SET_ROTATE_CIRCLE",
}

export const EventBus = new EventEmitter();